const Weekdays = [
  {
    full: 'Sunday',
    short: 'S',
    index: 0,
  },
  {
    full: 'Monday',
    short: 'M',
    index: 1,
  },
  {
    full: 'Tuesday',
    short: 'T',
    index: 2,
  },
  {
    full: 'Wednesday',
    short: 'W',
    index: 3,
  },
  {
    full: 'Thursday',
    short: 'T',
    index: 4,
  },
  {
    full: 'Friday',
    short: 'F',
    index: 5,
  },
  {
    full: 'Saturday',
    short: 'S',
    index: 6,
  },
];

export default Weekdays;
